export default __webpack_public_path__ + "roboto-v27-latin-700italic.43c077649e51429fefb9f694b5d532f7.woff";